var print = {
    data: ""
}

print.init = function () {
    $("#eguide_print").unbind("click.eguide_print");

    $("#eguide_print").bind("click.eguide_print", function () {
        if (window.ActiveXObject || (navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0)) {
            var title = ""
            if (navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0) {
                title = navigationWeb.getTitle()
            }

            var width = screen.width;
            var height = screen.height;

            var widthPopup = width / 2;
            var heightPopup = height / 2;

            var top = (width - widthPopup) / 4;
            var left = height - heightPopup;

            //var mywindow = window.open('', title, "width=" + widthPopup + ",height=" + heightPopup + ",top=" + top + ",left=" + left)
            var mywindow = window.open('', '_blank', "width=" + widthPopup + ",height=" + heightPopup + ",top=" + top + ",left=" + left)

            if (window.navigator.userAgent.indexOf("Edge") > -1) {
                mywindow.onload = function () {
                    print.writeData(mywindow, title)
                }
            }
            else {
                print.writeData(mywindow, title)
            }
        }
        else {
            $.ajax({
                url: "../../../../app/assets/template/print.html"
                , global: false
                , dataType: "text"
                , async: true
                , success: function success(data, textStatusAjax, jqXHRAjax) {
                    print.data = data
                    print.openWindow()
                }
                , error: function fail(error) {
                    console.log("error", error)
                }
            });
        }
    })
}

print.writeData = function (mywindow, title) {
    mywindow.document.write('<!DOCTYPE html><html id="printPage"><head><title>' + title + '</title>');
    mywindow.document.write('<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no">');
    mywindow.document.write('<meta http-equiv="X-UA-Compatible" content="IE=9.0">');
    mywindow.document.write('<link type="text/css" href="../../../../app/assets/css/app.css" rel="stylesheet">');
    mywindow.document.write('<link type="text/css" href="../../../../app/assets/css/print.css" media="print" rel="stylesheet">');
    mywindow.document.write('<script type="text/javascript" src="../../../../app/assets/libjs/jquery-3.2.1.min.js"></script>');
    mywindow.document.write("<script type='text/javascript'>$(document).ready(function() { if ($('.avertissement').length > 0) {\
        $('.avertissement').each(function() {\
                if ($(this).hasClass('information')) {\
                    $(this).find('.ico').prepend('<img src=\"../../../../app/common/img/icon-info-print.png\">');\
                } else if ($(this).hasClass('green')) { \
                    $(this).find('.ico').prepend('<img src=\"../../../../app/common/img/icon-green-print.png\">');\
                } else if ($(this).hasClass('attention')) {                                                      \
                    $(this).find('.ico').prepend('<img src=\"../../../../app/common/img/icon-attention-print.png\">');\
                } else {\
                    $(this).find('.ico').prepend('<img src=\"../../../../app/common/img/icon-warning-print.png\">');\
                }\
            }\
        )\
    }})   </script>")
    mywindow.document.write('</head><body id="previewPrint">');

    mywindow.document.write($("#app-content").html());
    mywindow.document.write('</body></html>');

    mywindow.document.close();

    setTimeout(function () {
        mywindow.print()
     mywindow.close()
    }, 250)
}

print.openWindow = function () {
    var title = navigationWeb.getTitle()
    var width = screen.width;
    var height = screen.height;

    var widthPopup = width / 2;
    var heightPopup = height / 2;

    var top = (width - widthPopup) / 4;
    var left = height - heightPopup;

    //var mywindow = window.open('', title, "width=" + widthPopup + ",height=" + heightPopup + ",top=" + top + ",left=" + left)
    var mywindow = window.open('', '_blank', "width=" + widthPopup + ",height=" + heightPopup + ",top=" + top + ",left=" + left)
    mywindow.document.write(print.data)
   mywindow.document.close()

    mywindow.onload = function () {
        print.injectData(mywindow)
    }
}

print.injectData = function (mywindow) {
    if (mywindow.document.readyState === "complete") {
        mywindow.postMessage({ event: "printData", data: $("#app-content").html() }, "*");
    }
    else {
        setTimeout(print.injectData, 150, mywindow)
    }

 
}